export default {
  "group": "Agrupación",
  "report": "Reporte",
  "lastDataReportPvt": "Última evaluación Cognus",
  "lastDataReportSleep": "Última evaluación FFD",
  "lastWeekReport": "Última semana",
  "lastMonthReport": "Último mes",
  "lastThreeMonthsReport": "Últimos tres meses",
  "lastSixMonthsReport": "Últimos seis meses",
  "lastYearReport": "Último año",
  "workShiftGroup": "Grupo de turno",
  "reportGroup": "Reporte resumido por",
  "operations": "Operación",
  "client": "Cliente",
  "zone": "Zona",
  "carrier": "Transportista",
  "carriers": "Transportistas",
  "plant": "Subcontrato",
  "from": "Desde",
  "to": "Hasta",
  "user": "Usuario",
  "closeSession": "Cerrar sesión",
  "profile": "Perfil",
  "noTags": "No Tags",
  "person": "Persona",
  "plantClient": "Geozonas",
  "search": "Buscar",
  "synchrousDate": "fecha sincronización",
  "inspectionDate": "fecha inspección",
  "filterFor": "Filtrar por",
  "date": "Fecha",
  "inspector": "Inspector",
  "note": "Nota",
  "type": "Tipo",
  "subtype": "Subtipo",
  "form": "Formulario",
  "transporter": "Transportista",
  "driver": "Conductor",
  "team": "Equipo",
  "fails": "Fallas",
  "nodata": "No hay más datos",
  "indicators": "Indicadores todos los transportistas",
  "FFDResult": "Resumen de resultados",
  "FFDSync": "Tasa de sincronización",
  "FFDRealization": "Tasa de realización",
  "show": "Mostrar",
  "ffdPvt": "Cognus",
  "ffdSleep": "FFD",
  "sleepWristband": "Pulseras de sueño",
  "pvtTest": "Prueba PVT",
  "help": "Ayuda",
  "repeatTour": "Repetir tour",
  "categoryFilters": "Filtros de categorías",
  "cancel": "Cancelar",
  "apply": "Aplicar",
  "ubicationpvt": "Ubicación PVT",
  "contract": "Contrato",
  "typeFilters": "Tipo / Subtipo",
  "customize": "Personalizar",
  "and": "y",
  "more": "más",
  "all": "TODOS",
  "noMatches": "No hay coincidencias"
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/filters/index.js